<script setup lang="ts">
import Text from '@uiKit/elements/Text.vue'

interface Props {
  modelValue: boolean
}

defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()
</script>

<template>
  <Text is="label" type="body-sm" class="terms-checkbox">
    <input
      type="checkbox"
      class="terms-checkbox__input"
      :checked="modelValue"
      @change="emit('update:modelValue', ($event.target as HTMLInputElement).checked)"
    />
    <Text is="span" class="terms-checkbox__text">
      <slot />
    </Text>
  </Text>
</template>

<style scoped>
.terms-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 0.15rem;
  cursor: pointer;
}

/* Native checkbox kept — kit doesn't ship a Checkbox element yet.
   TODO: replace with `<Checkbox>` when added. */
.terms-checkbox__input {
  flex-shrink: 0;
  margin-top: 3px;
  width: 15px;
  height: 15px;
  accent-color: var(--p-primary-600);
  cursor: pointer;
}

.terms-checkbox__text {
  line-height: 1.7;
}
</style>
